<template>
    <div :class="className" class="relative">
        <input :disabled="disabled" :placeholder="placeholder" v-model="address" />
        <div class="location_contain" v-if="openDP">
            <span class="location_tem" v-for="(loc, index) in locations" :key="index + loc" @click="setAddress(loc)">
                <img src="/icons/location_icon.svg" class="image_loc" />
                <span class="">{{ loc.name }}</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Addressinput",
    data() {
        return {
            debounce: null,
            address: "",
            locations: [],
            openDP: false,
            selectedAddress: {}
        }
    },
    watch: {
        value(val) {
            this.selectedAddress = val;
            this.address = val?.name;
            this.locations = [];
            this.openDP = false
        },
        address(val) {
            if (this.selectedAddress.name == this.address) return
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                this.getCloseLocation(val)
            }, 500);
        }
    },
    methods: {
        setAddress(_address_) {
            this.selectedAddress = _address_;
            this.address = this.selectedAddress?.name || "";
            this.locationDetails(_address_);
            this.locations = [];
            this.openDP = false
        },
        async getCloseLocation(val) {
            const res = await this.$_searchAddress({ query: val })
            this.locations = res.data.results;
            this.openDP = true
        }
    },
    props: {
        className: {
            type: String
        },
        placeholder: {
            type: String
        },
        value: {
            required: false
        },
        locationDetails: {
            required: true,
        },
         disabled: {
            type: Boolean
        },
    }
}
</script>

<style lang="scss" scoped>
.image_loc {
    @apply mr-2 w-[17px] opacity-50 mt-[2px]
}

.location_tem {
    @apply w-full text-sm border-b-[1px] border-gray-200 opacity-75 cursor-pointer px-1 flex items-start py-[6px];
}

.location_tem:nth-last-child(1) {
    @apply border-b-[0px]
}

.location_contain {
    @apply absolute top-[calc(100%+0.5rem)] left-0 bg-white w-full max-h-[200px] overflow-y-auto shadow-lg min-w-[300px] py-0 px-1 rounded z-10
}
</style>